import React from 'react';
import PropTypes from 'prop-types';

const SunIcon = props => {
    const { className, style } = props;

    return (
        <svg
            className={className}
            style={style}
            width="31px"
            height="32px"
            viewBox="0 0 31 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g id="layout" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="main_dark"
                    transform="translate(-1293.000000, -28.000000)"
                    fillRule="nonzero"
                >
                    <g id="sun-black-shape" transform="translate(1293.000000, 28.000000)">
                        <path
                            d="M30.4777931,11.0321655 C30.4298483,10.8535724 30.3110069,10.7350621 30.1205517,10.6752552 L24.9078621,8.96198621 L24.9078621,3.49908966 C24.9078621,3.30863448 24.8302345,3.15470345 24.675531,3.03481379 C24.4969379,2.91630345 24.3244138,2.89263448 24.1579034,2.96353103 L18.9452138,4.64137931 L15.7320828,0.214731034 C15.6257103,0.0715586207 15.470731,0 15.268469,0 C15.0658759,0 14.9115586,0.0718896552 14.8041931,0.214731034 L11.5910621,4.64137931 L6.37837241,2.96353103 C6.21158621,2.89230345 6.03933793,2.91630345 5.86074483,3.03481379 C5.70609655,3.15470345 5.6288,3.30896552 5.6288,3.49908966 L5.6288,8.96204138 L0.416331034,10.6753103 C0.225875862,10.7353931 0.106703448,10.8539034 0.0590896552,11.0322207 C-0.000662068966,11.2233379 0.0236137931,11.395531 0.130372414,11.5501793 L3.34383448,15.9768276 L0.130372414,20.4041379 C0.023337931,20.5469793 -0.000662068966,20.7198897 0.0590896552,20.9220966 C0.106703448,21.1007448 0.225544828,21.2199172 0.416331034,21.2790621 L5.62902069,22.992331 L5.62902069,28.4555586 C5.62902069,28.6459586 5.70631724,28.7999448 5.86102069,28.9191172 C6.03961379,29.0382897 6.2121931,29.0619586 6.37864828,28.9910621 L11.5913379,27.3125517 L14.804469,31.7399172 C14.9233103,31.8945655 15.0782897,31.9721931 15.2687448,31.9721931 C15.458869,31.9721931 15.6138483,31.8948966 15.7330759,31.7399172 L18.9462069,27.3125517 L24.1588966,28.9910621 C24.3253517,29.0622897 24.497931,29.0382897 24.6765241,28.9191172 C24.8311724,28.7999448 24.9088552,28.6456276 24.9088552,28.4555586 L24.9088552,22.9926069 L30.1215448,21.2793379 C30.3116138,21.2199172 30.4307862,21.1007448 30.4787862,20.9224276 C30.5382069,20.7201655 30.5142621,20.5472552 30.4075586,20.4044138 L27.1940966,15.9771034 L30.4075586,11.5504552 C30.5136552,11.395531 30.5372138,11.2232828 30.4777931,11.0321655 Z M24.7387034,19.9668414 C24.197131,21.2347586 23.4654345,22.3294345 22.5429517,23.2512 C21.6208,24.1743448 20.5257379,24.9060414 19.2582069,25.4470069 C17.9906759,25.9889103 16.6610207,26.2594207 15.268469,26.2594207 C13.8759724,26.2594207 12.5463172,25.9889655 11.278731,25.4470069 C10.0111448,24.9057103 8.91613793,24.1744 7.99404138,23.2512 C7.07188966,22.3294345 6.33986207,21.2343724 5.79828966,19.9668414 C5.25666207,18.6993103 4.9862069,17.369269 4.9862069,15.9768276 C4.9862069,14.5849931 5.25666207,13.2546207 5.79828966,11.9874207 C6.33986207,10.7195586 7.07155862,9.62554483 7.99404138,8.70234483 C8.91613793,7.78052414 10.0112,7.04816552 11.278731,6.50725517 C12.545931,5.96601379 13.8759724,5.69484138 15.268469,5.69484138 C16.6610207,5.69484138 17.9906759,5.96601379 19.2582069,6.50725517 C20.5254621,7.04855172 21.620469,7.78057931 22.5429517,8.70234483 C23.4650483,9.62548966 24.1970759,10.7198345 24.7387034,11.9874207 C25.2802759,13.2542897 25.5511172,14.5849931 25.5511172,15.9768276 C25.5511172,17.369269 25.2799448,18.6993655 24.7387034,19.9668414 Z"
                            id="Shape"
                            fill="#F6C358"
                        />
                        <circle
                            id="Oval"
                            fill="#FCD462"
                            cx="15.268469"
                            cy="15.985931"
                            r="8.70444138"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

SunIcon.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
};
SunIcon.defaultProps = {
    className: undefined,
    style: null,
};

export default SunIcon;
